import {
  getLocalOrDefault,
  setLocal,
  storageKeys,
} from '../../utility/localStorage.js';
import { fetch } from '../../utility/fetch.js';
import Vue from 'vue';

const STORAGE_KEY = storageKeys.currentUser;
const PATH_PREF_STORAGE_KEY = 'fullPath-Pref';

export default {
  state: {
    user: getLocalOrDefault(STORAGE_KEY, {}),
    showFullSharePaths: getLocalOrDefault(PATH_PREF_STORAGE_KEY, true),
    userCards: [],
  },
  mutations: {
    setCurrentUserId(state, id) {
      state.user.id = id;
      setLocal(STORAGE_KEY, JSON.stringify(state.user));
    },
    swapShortenPathsPreference(state) {
      state.showFullSharePaths = !state.showFullSharePaths;
      setLocal(PATH_PREF_STORAGE_KEY, JSON.stringify(state.showFullSharePaths));
    },
    setUserAdminStatus(state, isAdmin) {
      Vue.set(state.user, 'isAdmin', isAdmin);
    },
    setUserAnalystStatus(state, isAnalyst) {
      Vue.set(state.user, 'isAnalyst', isAnalyst);
    },
    setUserDashboardCards(state, userCards) {
      state.userCards = userCards;
    },
  },
  actions: {
    async FETCH_CURRENT_USER({ commit }) {
      const userId = await fetch('/CommonApi/CurrentUserId');
      commit('setCurrentUserId', userId[0]);
      try {
        await fetch('/Admin/IsAdmin');
        commit('setUserAdminStatus', true);
      } catch {
        commit('setUserAdminStatus', false);
      }
      try {
        await fetch('/AssetReview/IsAdmin');
        commit('setUserAnalystStatus', true);
      } catch {
        commit('setUserAnalystStatus', false);
      }
      return;
    },
    async FETCH_USER_CARDS({ commit }) {
      const userCards = await fetch('/Dashboard/GetUsersCards');
      commit('setUserDashboardCards', userCards);
      return;
    },
  },
  getters: {
    userId: (state) => state.user.id,
    isLoggedIn: (state) => !!state.user.id,
    hasFullSharePaths: (state) => state.showFullSharePaths,
    userIsAdmin: (state) => state.user.isAdmin,
    userIsAnalyst: (state) => state.user.isAnalyst,
    userDashboardCards: (state) => state.userCards,
  },
};
